import styled from 'styled-components';
import { Text } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px 200px 100px 250px;
  margin-top: 80px;
  ${({ center }) => (center ? 'align-items: center;' : '')};
`;

export const Title = styled(Text.Header)``;

export const Description = styled(Text.Secondary)``;
